<template>
  <div>
      
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>下载订单列表-配货单</span>
        </div>
      </el-col>
      <el-col :span="24">
        <el-form :inline="true" :model="queryParam" class="demo-form-inline" size="mini">
        <el-form-item label="推送日期：">
          <el-col :span="24">
            <el-date-picker type="date" placeholder="选择推送日期" v-model="queryParam.searchCreateTime" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <!-- <el-button size="mini" type="primary" icon="el-icon-search" @click="todylist">当日配货单</el-button> -->
        <!-- <el-button size="mini" type="primary" icon="el-icon-download" @click="dowanTodayBill">下载当日配货单</el-button> -->
      </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableDataDay" stripe border style="width: 100%">
        <el-table-column prop="billName" label="未下载配货单" width="600"/>
        <!-- <el-table-column label="订单日期" width="200">
          <template slot-scope="scope">
            {{ scope.row.orderProductTime ? scope.row.orderProductTime.substr(0, 10): '' }}
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="推送时间" width="200"/>
        <el-table-column label="文件大小" width="100">
          <template slot-scope="scope">{{ scope.row.billSize }} kb</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-download" @click="dowanBill(scope.row, 1)">
              {{ scope.row.downStatus == '1' ? '已下载':'下载' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange_t" :current-page="t_currentPage"
          :page-size="t_pagesize" layout="prev,pager,next" :total="t_pageTotal">
        </el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="billName" label="已下载配货单" width="600"/>
        <!-- <el-table-column label="订单日期" width="200">
            <template slot-scope="scope">
              {{ scope.row.orderProductTime ? scope.row.orderProductTime.substr(0, 10): '' }}
            </template>
          </el-table-column> -->
        <el-table-column prop="createTime" label="推送时间" width="200"/>
        <el-table-column prop="updateTime" label="下载时间" width="200" />
        <el-table-column label="文件大小" width="100">
          <template slot-scope="scope">{{ scope.row.billSize }} kb</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-download" @click="dowanBill(scope.row, 0)">
              {{ scope.row.downStatus == '1' ? '已下载':'下载' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="prev,pager,next" :total="pageTotal">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAction, downFile } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "shipAddress",
  data() {
    return {
      tableData: [],
      tableDataDay: [], // 今天的配货单
      textarea: "",
      isdefault: false,
      url: {
        list: "/provider/querMateBillList",
        todayList: "/provider/querMateBillTodayList",
        downLoadTodayBill: "/provider/downLoadTodayBill",
        downloadBill: "/provider/downloadBill",
      },
      queryParam:{
        searchCreateTime: ''
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      t_currentPage: 1, // 当前页码
      t_pagesize: 10, // 每页显示的行数
      t_pageTotal: 0,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    this.search();
  },
  methods: {
    list(page) {
      getAction(this.url.list, {
        pageNo: page,
        whId: this.$store.state.userInfo.id,
        searchCreateTime: this.queryParam.searchCreateTime,
        downStatus: '1'
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.result.records;
          this.pageTotal = res.data.result.total;
          // this.tableDataDay =  res.data.resultOther.todayList
        }
      });
    },
    todylist(page) {
      getAction(this.url.list, {
        pageNo: page,
        whId: this.$store.state.userInfo.id,
        searchCreateTime: this.queryParam.searchCreateTime,
        downStatus: '0'
      }).then((res) => {
        if (res.data.success) {
          this.tableDataDay =  res.data.result.records;
          this.t_pageTotal = res.data.result.total;
        }
      });
    },
    search() {
      this.list(1)
      this.todylist(1)
    },
    // 页面切换方法
    handleCurrentChange(val) {
      this.list(val);
      this.currentPage = val;
    },
    // 页面切换方法
    handleCurrentChange_t(val) {
      this.todylist(val);
      this.t_currentPage = val;
    },
    dowanBill(rows, uds) {
      // window.location.href = this.frontDomianURL + this.url.downloadBill + '?id='+rows.id+'&uds=1&whId='+this.$store.state.userInfo.id
      downFile(this.url.downloadBill, {
        id: rows.id,
        whId: this.$store.state.userInfo.id,
        uds: uds, //需要更新下载状态
      }).then((res) => {
        rows.downStatus = "1"
        try {
          let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", rows.billName);
            document.body.appendChild(link);
            link.click();
            link.remove()
        } catch (e) {
            console.log(e)
        }
      }).finally(() => {
        if (uds == 1) { 
          this.search();
        }
      });
    },
    dowanTodayBill() {
      downFile(this.url.downLoadTodayBill, {
        searchCreateTime: '',
        whUId: this.$store.state.userInfo.id,
      }).then((res) => {
        let dateStr = new Date();

        let yy = dateStr.getFullYear();
        let mm = dateStr.getMonth() + 1;
        let dd = dateStr.getDate();
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let a = document.createElement("a");
        a.setAttribute(
          "download",
          this.$store.state.userInfo.warehouseName +
            "配货单" +
            yy +"-"+
            mm +"-"+
            dd +
            ".xls"
        );
        a.href = url;
        a.click();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
  display: flex;
  justify-content: space-between;
}
.el-cascader {
  display: block;
}
</style>
